import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
	HttpService,
	GET,
	Adapter,
	POST,
	Body,
	ResponeTypeEnum,
} from "@royalty/httpclient";

@Injectable()
export class ReportService extends HttpService {
	@GET("reportinggroup/list")
	@Adapter(null, { isAdmin: true })
	getReportGroups(): Observable<any> {
		return null;
	}

	@POST("cashreport/summaryreport")
	@Adapter(null, { isAdmin: true })
	getCashSummaryReport(@Body data: string): Observable<any> {
		return null;
	}

	@POST("cashreport/summaryreportfile")
	@Adapter(null, { isAdmin: true, responeType: ResponeTypeEnum.blob })
	generateCashSummaryReport(@Body data: string): Observable<any> {
		return null;
	}

	@POST("salereport/salesummary")
	@Adapter(null, { isAdmin: true })
	getSaleSummaryReport(@Body data: string): Observable<any> {
		return null;
	}

	@POST("salereport/summaryreportfile")
	@Adapter(null, { isAdmin: true, responeType: ResponeTypeEnum.blob })
	generateSaleSummaryReport(@Body data: string): Observable<any> {
		return null;
	}

	@POST("salereport/getSaleDetailReport")
	@Adapter(null, { isAdmin: true })
	getSaleDetailReport(@Body data: string): Observable<any> {
		return null;
	}

	@POST("salereport/getexcelreport")
	@Adapter(null, { isAdmin: true, responeType: ResponeTypeEnum.blob })
	getexcelreport(@Body data: string): Observable<any> {
		return null;
	}

	@POST("itemreport/getitemReport")
	@Adapter(null, { isAdmin: true, showProgress: false })
	getitemReport(@Body data: string): Observable<any> {
		return null;
	}

	@POST("itemreport/getexcelreport")
	@Adapter(null, { isAdmin: true, responeType: ResponeTypeEnum.blob })
	generateMenuItemSalesAnalysisReport(@Body data: string): Observable<any> {
		return null;
	}

	@POST("report/getOpenSalesReport")
	@Adapter(null, { isAdmin: true })
	getOpenSalesReport(@Body data: string): Observable<any> {
		return null;
	}

	@POST("report/generateOpenSalesReportReport")
	@Adapter(null, { isAdmin: true })
	generateOpenSalesReportReport(@Body data: string): Observable<any> {
		return null;
	}

	@POST("salereport/test-export-sale-report")
	@Adapter(null, { isAdmin: true })
	testExportSaleReport(@Body data: string): Observable<any> {
		return null;
	}

	@POST("saleitemreport/getsaleitemreport")
	@Adapter(null, { isAdmin: true })
	getSaleItemReport(@Body data: string): Observable<any> {
		return null;
	}
}
